import type { SelectedFilters } from '@/hooks/filters/useCompanyAttributesFilters';
import type { CompanyAttributeMap } from '@/utils/company';

import { Filters } from '@/constants/Filters';

interface GetAttributeEntriesWithSelectedValuesParams {
    selectedCompanyAttributes?: CompanyAttributeMap;
    filters: SelectedFilters;
}

const STANDARD_KEYS: string[] = [
    Filters.DEPARTMENTS,
    Filters.EMPLOYEE_LEVELS,
    Filters.JOB_TITLES,
    Filters.COMPANY_ADDRESSES,
    Filters.MANAGERS,
];

export const getAttributeEntriesWithSelectedValues = ({
    selectedCompanyAttributes,
    filters,
}: GetAttributeEntriesWithSelectedValuesParams) => {
    const attributeEntries = Object.entries(selectedCompanyAttributes ?? {});
    const customValueOwners = new Map<string, string>();

    attributeEntries
        .filter(([key]) => !STANDARD_KEYS.includes(key))
        .forEach(([key, attribute]) =>
            (attribute.values ?? []).forEach((value) => {
                if (value.id) {
                    customValueOwners.set(value.id, key);
                }
            }),
        );

    return attributeEntries.map(([key, attribute]) => {
        const isCustomAttribute = !STANDARD_KEYS.includes(key);

        const filterKey = isCustomAttribute ? 'customAttributes' : key;

        const selectedValues = (filters[filterKey] ?? [])
            .map((v) => v.id)
            .filter(
                (id): id is string =>
                    !!id && (!isCustomAttribute || (customValueOwners.get(id) ?? key) === key),
            );

        return { attribute, selectedValues };
    });
};
